import { useState } from "react";
import { toast } from "react-hot-toast";

// Use the shared, env-aware axios instance from src/api/axios.js. That
// file is inside src/api/, which is the only directory the production
// deploy workflow rewrites at build time (UAT host → prod host). A
// hardcoded host here would silently keep pointing at UAT in production.
import { axiosInstance } from "api/axios";

export const useParticipantJoinVideoStandalone = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const joinVideo = async ({
    appointmentId,
    meetingId,
    firstName,
    surName,
    yearOfBirth,
    dateOfBirth,
  }) => {
    if (!appointmentId || !meetingId) {
      throw new Error("Appointment ID and Meeting ID are required");
    }

    // A practice asks for one set of details or the other (KIN-1953); the backend answers
    // the wrong set for its mode with a 400, so only the set the form collected is sent.
    const hasNameDetails = !!firstName && !!surName && !!yearOfBirth;

    if (!dateOfBirth && !hasNameDetails) {
      throw new Error(
        "Either a date of birth, or first name, surname and year of birth are required"
      );
    }

    const verificationDetails = dateOfBirth
      ? { dateOfBirth }
      : { firstName, surName, yearOfBirth };

    setIsLoading(true);
    setError(null);

    try {
      const tenantVal = localStorage.getItem("kinesin-tenant") || "0";

      const response = await axiosInstance.post(
        `/api/practice/v1/${tenantVal}/video/appointments/participant-join`,
        {
          appointmentId,
          meetingId,
          ...verificationDetails,
        },
        {
          headers: {
            Accept: "*/*",
            "Content-Type": "application/json",
          },
        }
      );

      setIsLoading(false);
      return response.data;
    } catch (err) {
      console.error("Error joining video call as participant:", err);
      const errorMessage =
        err.response?.data?.message ||
        "Failed to join video call. Please try again.";
      setError(errorMessage);
      toast.error(errorMessage);
      setIsLoading(false);
      throw err;
    }
  };

  return {
    joinVideo,
    isLoading,
    error,
  };
};
